import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from '@springcare/sh-component-library';
import { useIFramePageContext } from '../contexts';
export var IFrameContent = function () {
    var _a = useIFramePageContext(), iframeUrl = _a.iframeUrl, isLoading = _a.isLoading;
    if (!iframeUrl || isLoading)
        return _jsx(Spinner, {});
    return _jsx("iframe", { src: iframeUrl, width: "100%", height: "100%", "data-testid": "iframeContent" });
};
